import jwtDecode from 'jwt-decode';

export const hasExpiredToken = (token) => {
    console.log("hasExpiredToken")
    const { exp } = jwtDecode(token);
    //const currentData = new Date().toLocaleTimeString();
    const currentData = Math.round(Date.now() / 1000); 

    console.log(exp)
    console.log(currentData)
    //console.log(currentDataTime)
    if (exp <= currentData) {
        console.log("Session expiro")
        return true;
    }

    return false;
}